import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {styled} from "@mui/material/styles";

import InfoCircleIcon from "components/icons/InfoCircleIcon";
import {blue500, blue600, grey25, greyishBlue50, greyishBlue200, greyishBlue500, greyishBlue700, greyishBlue900} from "assets/jss/main";

ListingEmptyState.propTypes = {
    titleId: PropTypes.string.isRequired,
    descriptionId: PropTypes.string,
    ctaLabelId: PropTypes.string,
    ctaVariant: PropTypes.oneOf(['primary', 'secondary']),
    ctaHref: PropTypes.string,
    onCtaClick: PropTypes.func,
};

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    padding: '96px 24px',
    backgroundColor: '#fff'
});

const IconCircle = styled('div')({
    width: '72px',
    height: '72px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: greyishBlue50
});

const Title = styled('p')({
    margin: 'unset',
    color: greyishBlue900,
    fontSize: '16px',
    fontWeight: 600,
    textAlign: 'center'
});

const Description = styled('p')({
    margin: 'unset',
    maxWidth: '420px',
    color: greyishBlue500,
    fontSize: '14px',
    fontWeight: 400,
    textAlign: 'center'
});

const Cta = styled('a', {
    shouldForwardProp: (prop) => prop !== 'variant'
})(({variant}) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '10px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    textDecoration: 'none',
    cursor: 'pointer',
    ...(variant === 'secondary' ? {
        backgroundColor: '#fff',
        border: `1px solid ${greyishBlue200}`,
        color: greyishBlue700,
        '&:hover': {
            backgroundColor: grey25,
            color: greyishBlue700
        }
    } : {
        backgroundColor: blue500,
        border: 'none',
        color: '#fff',
        '&:hover': {
            backgroundColor: blue600,
            color: '#fff'
        }
    })
}));

function ListingEmptyState({titleId, descriptionId, ctaLabelId, ctaVariant = 'primary', ctaHref, onCtaClick}) {
    return (
        <Container>
            <IconCircle>
                <InfoCircleIcon size={32} color={greyishBlue500}/>
            </IconCircle>
            <Title>
                <FormattedMessage id={titleId}/>
            </Title>
            {descriptionId && (
                <Description>
                    <FormattedMessage id={descriptionId}/>
                </Description>
            )}
            {ctaLabelId && (ctaHref || onCtaClick) && (
                <Cta variant={ctaVariant} href={ctaHref} onClick={onCtaClick}>
                    <FormattedMessage id={ctaLabelId}/>
                </Cta>
            )}
        </Container>
    );
}

export default ListingEmptyState;
